module.exports = __webpack_public_path__ + "img/q.5ee07d08.jpg";